import graphql__e3fd2190413050b3602b from "./__generated__/CreateReverseInvoiceDialog_invoice.graphql.ts";
import graphql__c0b7e4e68091cc0a5ee9 from "./__generated__/CreateReverseInvoiceDialogMutation.graphql.ts";import * as React from "react";
import {useIntl} from "react-intl";
import {commitMutation, graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import Hint from "../presentational/Hint";
import {useNavigate} from "react-router-dom";
import {CreateReverseInvoiceDialogMutation} from "./__generated__/CreateReverseInvoiceDialogMutation.graphql";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";

type CreateReverseInvoiceDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const CreateReverseInvoiceDialog: React.FC<CreateReverseInvoiceDialogProps> = (props) => {
    const intl = useIntl();

    const invoice = useFragment(
        graphql__e3fd2190413050b3602b,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<CreateReverseInvoiceDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__c0b7e4e68091cc0a5ee9,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    props.handleCloseDialog();
                    navigate('/invoices');
                },
                onError: (error) => {
                    console.error(error);
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToCreateReverseInvoice'})
            }
        )
    }

    const initialValues = {
        relatedInvoiceIdentifier: invoice.id
    }

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} headline={intl.formatMessage({id: 'dialog.CreateReverseInvoiceDialog.headline'})} submitLabel={intl.formatMessage({id: 'button.create'})}>
            <Section>
                <Row>
                    <div className="text-gray-900">
                        <p>{intl.formatMessage({id: 'dialog.CreateReverseInvoiceDialog.question'}, {invoiceNumber: invoice.invoiceNumber})}</p>
                    </div>
                    <Hint className="py-4">
                        {intl.formatMessage({id: 'dialog.CreateReverseInvoiceDialog.hint'}, {customer: invoice.customerAccount.customerName})}
                    </Hint>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default CreateReverseInvoiceDialog;
